import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@mui/material';
import { getPublicConfig } from '../services/AuthService';
import { initializeGoogleIdentity, loadGoogleScript } from '../services/GoogleAuth';

const GoogleSignInButton = ({ onCredential, onUnavailable }) => {
    const buttonRef = useRef(null);
    const credentialHandlerRef = useRef(onCredential);
    const unavailableHandlerRef = useRef(onUnavailable);
    const [ready, setReady] = useState(false);

    useEffect(() => {
        credentialHandlerRef.current = onCredential;
    }, [onCredential]);

    useEffect(() => {
        unavailableHandlerRef.current = onUnavailable;
    }, [onUnavailable]);

    useEffect(() => {
        let cancelled = false;

        const initialize = async () => {
            try {
                const config = await getPublicConfig();
                const clientId = config?.googleClientId;
                if (!clientId) {
                    unavailableHandlerRef.current?.();
                    return;
                }

                await loadGoogleScript();
                if (cancelled || !buttonRef.current || !window.google?.accounts?.id) return;

                initializeGoogleIdentity(clientId, response => credentialHandlerRef.current?.(response));
                buttonRef.current.replaceChildren();
                window.google.accounts.id.renderButton(buttonRef.current, {
                    type: 'standard',
                    theme: 'outline',
                    size: 'large',
                    text: 'continue_with',
                    shape: 'rectangular',
                    width: Math.min(320, Math.max(220, window.innerWidth - 96)),
                });
                setReady(true);
            } catch (err) {
                unavailableHandlerRef.current?.(err);
            }
        };

        initialize();
        return () => {
            cancelled = true;
            setReady(false);
        };
    }, []);

    return (
        <Box
            sx={{ display: ready ? 'flex' : 'none', justifyContent: 'center', width: '100%', minHeight: ready ? 40 : 0 }}
        >
            <div ref={buttonRef} />
        </Box>
    );
};

export default GoogleSignInButton;
